// client/src/coms/comsApi.js
function computeAuthorityOrigin() {
  if (typeof window === 'undefined' || !window.location) return '';
  const origin = window.location.origin || '';

  try {
    const url = new URL(origin);
    const host = url.host || '';

    if (host.endsWith('voxemera.com')) {
      const paHost = host.replace(/voxemera\.com$/, 'point-atlas.io');
      return `${url.protocol}//${paHost}`;
    }

    return '';
  } catch {
    return '';
  }
}

export const AUTHORITY_ORIGIN = computeAuthorityOrigin();

function normalizePath(path) {
  const p = String(path || '');
  if (!p) return '';
  return p.startsWith('/') ? p : `/${p}`;
}

function buildComsUrl(path) {
  const suffix = normalizePath(path);
  return `/api/coms${suffix}`;
}

function buildApiUrl(path) {
  const suffix = normalizePath(path);
  return `/api${suffix}`;
}

function parseJsonOrNull(text) {
  try {
    return text ? JSON.parse(text) : null;
  } catch {
    return null;
  }
}

async function safeText(res) {
  try {
    return await res.text();
  } catch {
    return '';
  }
}

export async function comsApiGet(path) {
  const url = buildComsUrl(path);
  const res = await fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });

  if (!res.ok) {
    const text = await safeText(res);
    const err = new Error(`GET ${url} failed: ${res.status} ${text}`);
    err.status = res.status;
    err.data = parseJsonOrNull(text);
    throw err;
  }

  return res.json();
}

export async function comsApiPost(path, body) {
  const url = buildComsUrl(path);
  const res = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify(body || {}),
  });

  if (!res.ok) {
    const text = await safeText(res);
    const err = new Error(`POST ${url} failed: ${res.status} ${text}`);
    err.status = res.status;
    err.data = parseJsonOrNull(text);
    throw err;
  }

  return res.json();
}

export async function comsApiPatch(path, body) {
  const url = buildComsUrl(path);
  const res = await fetch(url, {
    method: 'PATCH',
    credentials: 'include',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify(body || {}),
  });

  if (!res.ok) {
    const text = await safeText(res);
    const err = new Error(`PATCH ${url} failed: ${res.status} ${text}`);
    err.status = res.status;
    err.data = parseJsonOrNull(text);
    throw err;
  }

  const ct = String(res.headers.get('content-type') || '');
  if (ct.includes('application/json')) {
    try {
      return await res.json();
    } catch {
      return { ok: true };
    }
  }

  return { ok: true };
}

export async function comsApiPut(path, body) {
  const url = buildComsUrl(path);
  const res = await fetch(url, {
    method: 'PUT',
    credentials: 'include',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify(body || {}),
  });

  if (!res.ok) {
    const text = await safeText(res);
    const err = new Error(`PUT ${url} failed: ${res.status} ${text}`);
    err.status = res.status;
    err.data = parseJsonOrNull(text);
    throw err;
  }

  return res.json();
}

export async function comsApiDelete(path) {
  const url = buildComsUrl(path);
  const res = await fetch(url, {
    method: 'DELETE',
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });

  if (!res.ok) {
    const text = await safeText(res);
    const err = new Error(`DELETE ${url} failed: ${res.status} ${text}`);
    err.status = res.status;
    err.data = parseJsonOrNull(text);
    throw err;
  }

  const ct = String(res.headers.get('content-type') || '');
  if (ct.includes('application/json')) {
    try {
      return await res.json();
    } catch {
      return { ok: true };
    }
  }

  return { ok: true };
}

export async function apiGet(path) {
  const url = buildApiUrl(path);
  const res = await fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });

  if (!res.ok) {
    const text = await safeText(res);
    const err = new Error(`GET ${url} failed: ${res.status} ${text}`);
    err.status = res.status;
    err.data = parseJsonOrNull(text);
    throw err;
  }

  return res.json();
}

export async function apiPost(path, body) {
  const url = buildApiUrl(path);
  const res = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify(body || {}),
  });

  if (!res.ok) {
    const text = await safeText(res);
    const err = new Error(`POST ${url} failed: ${res.status} ${text}`);
    err.status = res.status;
    err.data = parseJsonOrNull(text);
    throw err;
  }

  return res.json();
}

export async function apiPatch(path, body) {
  const url = buildApiUrl(path);
  const res = await fetch(url, {
    method: 'PATCH',
    credentials: 'include',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify(body || {}),
  });

  if (!res.ok) {
    const text = await safeText(res);
    const err = new Error(`PATCH ${url} failed: ${res.status} ${text}`);
    err.status = res.status;
    err.data = parseJsonOrNull(text);
    throw err;
  }

  const ct = String(res.headers.get('content-type') || '');
  if (ct.includes('application/json')) {
    try {
      return await res.json();
    } catch {
      return { ok: true };
    }
  }

  return { ok: true };
}

export async function apiDelete(path) {
  const url = buildApiUrl(path);
  const res = await fetch(url, {
    method: 'DELETE',
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });

  if (!res.ok) {
    const text = await safeText(res);
    const err = new Error(`DELETE ${url} failed: ${res.status} ${text}`);
    err.status = res.status;
    err.data = parseJsonOrNull(text);
    throw err;
  }

  const ct = String(res.headers.get('content-type') || '');
  if (ct.includes('application/json')) {
    try {
      return await res.json();
    } catch {
      return { ok: true };
    }
  }

  return { ok: true };
}